export default __webpack_public_path__ + "static/media/alphie-whales-1.6f4c860d.png";